import React, { useState } from 'react';
import { Row, Col, Card, Tabs } from 'antd';
import { profile_banner } from '../utils/ImagePath';
import FlightBookingHistory from './FlightBookingHistory';
import HotelBookingHistory from './HotelBookingHistory';
import HolidayBookingHistory from './HolidayBookingHistory';


const MyBooking = () => {
    const [activeKey, setActiveKey] = useState('1');

    const onChangeTabs = (key) => {
        setActiveKey(key);
    };

    const mainTabs = [
        {
            key: 'flight',
            label: 'Flight',
            children: <FlightBookingHistory />,
        },
        {
            key: 'hotel',
            label: 'Hotel',
            children: <HotelBookingHistory />,
        },
        {
            key: 'holiday',
            label: 'Holiday',
            children: <HolidayBookingHistory />,
        },
    ];



    return (
        <>
            <section className='my-booking mb-5'>
                <div className='bg-primary position-relative' style={{ height: "160px", marginBottom: "-60px" }}>
                    <img loading="lazy" src={profile_banner} alt='#' className='w-100 position-absolute' height={160} style={{ objectFit: "cover" }} />
                    <div className='w-100' style={{ background: "radial-gradient(transparent, #214a93)", height: "160px", position: "absolute" }}></div>
                    <div className='container'>
                        <Row gutter={16}>
                            <Col md={12}>
                                <h2 className='text-white pt-2'>My Booking</h2>
                            </Col>
                            <Col md={12}></Col>
                        </Row>
                    </div>
                </div>

                <div className='container'>
                    <Row gutter={16}>
                        <Col md={24}>
                            <Card>
                                <div className='d-flex align-items-center justify-content-between pb-2 mb-2'>
                                    <h4>My Booking</h4>
                                </div>
                                <Tabs className='mainTabs' defaultActiveKey="1" items={mainTabs} onChange={onChangeTabs} />
                            </Card>
                        </Col>
                    </Row>
                </div>

            </section>
        </>
    );
};

export default MyBooking;